import React from "react";
import "./OurTeam.css";
import team1 from "../../../Image/team/WhatsApp Image 2026-01-13 at 1.10.11 PM.jpeg";
import team2 from "../../../Image/team/WhatsApp Image 2026-01-13 at 3.13.26 PM.jpeg";

const teamData = [
  {
    id: 1,
    name: "Atul Kumar",
    role: " Owner CEO / Director ",
    img: team1,
    active: true,
  },
  {
    id: 2,
    name: " Shubham Verma ",
    role: "Manager",
    img: team2,
  },
  // {
  //   id: 3,
  //   name: "Michael S. John",
  //   role: "Taxi Driver",
  //   img: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
  // },
  // {
  //   id: 4,
  //   name: "Maya D'a Paric",
  //   role: "Taxi Driver",
  //   img: "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
  // },
];

const OurTeam = () => {
  return (
    <section className="team-section">
      <h2 className="team-title">Meet Our Team</h2>

      <div className="team-grid">
        {teamData.map((item) => (
          <div
            key={item.id}
            className={`team-card ${item.active ? "active" : ""}`}
          >
            <div className="image-box">
              <img src={item.img} alt={item.name} />

              <button className="plus-btn">+</button>
            </div>

            <div className="info-box">
              <h3>{item.name}</h3>
              <p>{item.role}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default OurTeam;
